import { render, staticRenderFns } from "./ShowEHR.vue?vue&type=template&id=13c7c9bd&"
import script from "./ShowEHR.vue?vue&type=script&lang=js&"
export * from "./ShowEHR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports